import useDocument from '@app/hooks/documents/useDocument';

import { InPersonDetail, InPersonSigner } from '../../types';

export default function useInPersonDetail({
  staleTime = 1000 * 10,
  documentId,
}: {
  staleTime?: number;
  documentId: string;
}) {
  return useDocument<InPersonDetail>({
    refetchOnWindowFocus: false,
    staleTime,
    documentId,
    select: (document): InPersonDetail => ({
      documentId: document.documentId,
      name: document.name,
      hosts: document.hosts,
      requester: document.requester,
      currentSigningOrder: document.currentSigningOrder,
      signings: document.signings,
      inPersonSigners: document.participants
        .filter((p) => p.host && p.signingMethod.methodType === 'IN_PERSON')
        .map<InPersonSigner>((p) => ({
          name: p.name,
          participantId: p.participantId,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          host: p.host!,
          signingOrder: p.signingOrder,
          signingExpiryDate: p.signingExpiryDate,
          contactInfo: p.signingMethod.contactInfo,
        })),
    }),
  });
}
